import { EndpointRequest } from "../../_system/EndpointRequest";
import {
  AvailabilityRequestDto as RequestDto,
  AvailabilityResponseDto as ResponseDto,
} from "../../api/availability/dtos";
import { Api } from "../../api";
import format from "date-fns/format";
import { PackageAvailability } from "../../models";

type Data = PackageAvailability[];

interface CallParams {
  id: number;
  locationId: number;
  dates: Date[];
  weekdays?: number | number[] | null;
  personTypes: {
    id: number;
    quantity: number;
  }[];
  activitiesOrder: { id: number; name: string }[];
}
export const timeSlots = new EndpointRequest<
  RequestDto,
  ResponseDto,
  Data,
  CallParams
>(
  "PACKAGE_TIME_SLOTS",
  Api.getTimeSlots,
  ({ data }, callParams) => {
    return data
      .map(({ packages }) => {
        if (packages[0]?.package_id !== callParams.id) return [];
        const results = Object.entries(packages[0].results);
        return results.map(
          ([date, item]) => new PackageAvailability({ ...item, date })
        );
      })
      .flat(1);
  },
  (params) => {
    const {
      locationId,
      id,
      dates,
      weekdays,
      personTypes,
      activitiesOrder,
    } = params;

    return {
      location_id: locationId,
      dates: dates.map((date) => format(date, "dd-MM-yyyy")),
      weekdays: weekdays
        ? Array.isArray(weekdays)
          ? weekdays
          : [weekdays]
        : [],
      packages: [
        {
          package_id: id,
          person_types: personTypes.map(({ id, quantity }) => ({
            person_type_id: id,
            quantity,
          })),
          activities_order: activitiesOrder.map(({ id }) => id),
        },
      ],
      activities: [],
    };
  }
);
